var initAnalytics = function () {
	$$.yandexMetrika = new $$.YandexMetrika(window.yaCounter35097645);
	$$.googleAnalytics = new $$.GoogleAnalytics();
	$$.FacebookPixel = new $$.FacebookPixel();
	/**
	 * Простые цели
	 */

	// Скачать прайс-лист монтажных работ
	$('.js-click-installation-download-price').on('click', () => {
		$$.yandexMetrika.reachGoal('installation-download-price');
		$$.googleAnalytics.reachPage('/virtual/installation-download-price');
	});

	// Скачать прайс-листы со страницы плайс листов
	$('.js-click-prices-download-price').on('click', () => {
		$$.yandexMetrika.reachGoal('prices-download-price');
		$$.googleAnalytics.reachPage('/virtual/prices-download-price');
	});

	// Обратная связь через email
	$('.js-click-email-feedback').on('click', () => {
		$$.yandexMetrika.reachGoal('email-feedback');
		$$.googleAnalytics.reachPage('/virtual/email-feedback');
	});

	/**
	 * Состовные цели
	 */

	var instalationForms = $('.js-click-installation-forms form');

	// Заказ звонка со страницы “монтаж” (первое взаимодействие)
	instalationForms.eq(0).one('change', 'input', () => {
		$$.yandexMetrika.reachGoal('installation-order-call-input');
		$$.googleAnalytics.reachPage('/virtual/installation-order-call-input');
	});

	// Отправка формы (Подробный расчёт монтажа — бесплатно!)
	// instalationForms.eq(0).one('click', '[type="submit"]', () => {
	instalationForms.eq(0).one('tabFormSubmit', () => {
		$$.yandexMetrika.reachGoal('installation-order-call-submit');
		$$.googleAnalytics.reachPage('/virtual/installation-order-call-submit');
	});

	// Обратная связь
	instalationForms.eq(1).one('change', 'input', () => {
		$$.yandexMetrika.reachGoal('installation-feedback-input');
		$$.googleAnalytics.reachPage('/virtual/installation-feedback-input');
	});

	// Отправка формы Обратная связь (форма после расчета монтажа)
	//	instalationForms.eq(1).one('click', '[type="submit"]', () => {
	instalationForms.eq(1).one('tabFormSubmit', () => {
		$$.yandexMetrika.reachGoal('installation-order-call-submit');
		$$.googleAnalytics.reachPage('/virtual/installation-order-call-submit');
	});

	var headerForms = $('.js-header-wrapper .call-me form');

	// Клик по телефону
	$('.js-upper-header .js-feedback').on('click', () => {
		$$.yandexMetrika.reachGoal('header-phone-click');
		$$.googleAnalytics.reachPage('/virtual/header-phone-click');
	});

	// Заказ звонка из хеадера (первое взаимодействие)
	headerForms.eq(0).one('change', 'input', () => {
		$$.yandexMetrika.reachGoal('header-order-call-input');
		$$.googleAnalytics.reachPage('/virtual/header-order-call-input');
	});

	// Заказ звонка из хеадера (отправка)
	//	headerForms.eq(0).one('click', '[type="submit"]', () => {
	headerForms.eq(0).one('headerFormSubmit', () => {
		$$.yandexMetrika.reachGoal('header-order-call-submit');
		$$.googleAnalytics.reachPage('/virtual/header-order-call-submit');
	});

	// Обратная связь из хеадера (первое взаимодействие)
	headerForms.eq(1).one('change', 'input', () => {
		$$.yandexMetrika.reachGoal('header-feedback-input');
		$$.googleAnalytics.reachPage('/virtual/header-feedback-input');
	});

	// Обратная связь из хеадера (отправка)
	//	headerForms.eq(1).one('click', '[type="submit"]', () => {
	headerForms.eq(1).one('headerFormSubmit', () => {
		$$.yandexMetrika.reachGoal('header-feedback-submit');
		$$.googleAnalytics.reachPage('/virtual/header-feedback-submit');
	});

	var pricesForms = $('.js-partner-form form');

	// Заказ звонка прайс листы (первое взаимодействие)
	pricesForms.one('change', 'input', () => {
		$$.yandexMetrika.reachGoal('prices-order-call-input');
		$$.googleAnalytics.reachPage('/virtual/prices-order-call-input');
	});

	// Заказ звонка прайс листы (отправка)
	//	pricesForms.one('click', '[type="submit"]', () => {
	pricesForms.one('partnerFormSubmit', () => {
		$$.yandexMetrika.reachGoal('prices-order-call-submit');
		$$.googleAnalytics.reachPage('/virtual/prices-order-call-submit');
	});

	// Оформление заказа
	$('.js-cart .js-order').on('click', () => {
		$$.yandexMetrika.reachGoal('cart-order-click');
		$$.googleAnalytics.reachPage('/virtual/cart-order-click');
	});

	// Далее заказа
	$('.js-delivery .js-submit').on('click', () => {
		$$.yandexMetrika.reachGoal('delivery-next-click');
		$$.googleAnalytics.reachPage('/virtual/delivery-next-click');
	});

	// Далее оплаты
	$('.js-pay-page .js-pay-next').on('click', () => {
		$$.yandexMetrika.reachGoal('pay-next-click');
		$$.googleAnalytics.reachPage('/virtual/pay-next-click');
	});

	// Оформить последней страницы
	$('.js-order-finish .js-order-finish-submit').on('click', () => {
		var data = {
			value: parseFloat($('.js-form input[name=ORDER_PRICE]').val()),
			currency: 'RUB'
		};

		$$.FacebookPixel.reachGoal('Purchase', data);
		$$.yandexMetrika.reachGoal('order-finish-submit');
		$$.googleAnalytics.reachPage('/virtual/order-finish-submit');
	});

	//  Узнать как заказать
	$('.card .js-feedback').on('click', () => {
		$.get('/.ajax/getSessionParam.php?howToOrder=true')
			.done((data) => {
				if (data === 'true') {
					$$.yandexMetrika.reachGoal('how-to-order-click');
					$$.googleAnalytics.reachPage('/virtual/how-to-order-click');
				}
			});
	});

	//  Регистрация
	$('.js-click-header-registration').on('click', (event) => {
		event.preventDefault();

		$$.yandexMetrika.reachGoal('do-registration-click');
		$$.googleAnalytics.reachPage('/virtual/do-registration-click');

		setTimeout("document.location.href='" + $(event.currentTarget).attr('href') + "'", 100);
	});

	//  Регистрация форма

	var registrationForm = $('.js-registration-page form');

	registrationForm.one('change', 'input', () => {
		$$.yandexMetrika.reachGoal('do-registration-input');
		$$.googleAnalytics.reachPage('/virtual/do-registration-input');
	});

	// Форма регистрации (отправка)
	//	registrationForm.one('click', '[type="submit"]', () => {
	registrationForm.one('registrationFormSubmit', () => {
		$$.yandexMetrika.reachGoal('do-registration-submit');
		$$.googleAnalytics.reachPage('/virtual/do-registration-submit');
	});

	//  Регистрация на событие форма
	var registrationEventForm = $('.js-registration-event-form');

	registrationEventForm.one('change', 'input', () => {
		$$.yandexMetrika.reachGoal('do-registration-event-input');
		$$.googleAnalytics.reachPage('/virtual/do-registration-event-input');
	});

	// Форма регистрации на событие (отправка)
	//	registrationEventForm.one('click', '[type="submit"]', () => {
	registrationEventForm.one('registrationEventFormSubmit', () => {
		$$.yandexMetrika.reachGoal('do-registration-event-submit');
		$$.googleAnalytics.reachPage('/virtual/do-registration-event-submit');
	});

	// Клик на кнопку добавить в корзину

	$('.js-add-to-cart').on('click', () => {
		$$.yandexMetrika.reachGoal('add-to-cart');
		$$.googleAnalytics.reachPage('/virtual/add-to-cart');
		$$.FacebookPixel.reachGoal('AddToCart');
	});

	//ПРОМО САЙТ
	//клик на кнопку "заказать"

	$('.b-promo-cam .js-open-popup[data-popup=order]').on('click', () => {
		$$.yandexMetrika.reachGoal('order-on-landing');
		$$.googleAnalytics.reachPage('/virtual/order-on-landing');
	});

	//клик на кнопку "купить" в попапе покупки

	$('.b-promo-cam .js-popup-content[data-popup-content-name=order] .g-button').on('click', () => {
		$$.yandexMetrika.reachGoal('buy-on-landing');
		$$.googleAnalytics.reachPage('/virtual/buy-on-landing');
	});

	//клик на кнопку "заказать звонок"

	$('.b-promo-cam [data-popup=call-me]').on('click', () => {
		$$.yandexMetrika.reachGoal('call-me-on-landing');
		$$.googleAnalytics.reachPage('/virtual/call-me-on-landing');
	});

	//клик на кнопку "отправить" в попапе заказа звонка
	
	//	$('.b-promo-cam .js-partner-form .submit').on('click', () => {
	$('.b-promo-cam .js-partner-form').on('partnerFormSubmit', () => {
		$$.yandexMetrika.reachGoal('send-call-request-on-landing');
		$$.googleAnalytics.reachPage('/virtual/send-call-request-on-landing');
	});

};
